import { Dispatch } from 'redux'

import { CodeDividers } from 'common/types/code'
import { setCodeDivider, setCustomWidgetDimensions } from 'store/user'

export const resetCustomDimensionsOnAIWidgetClose = (dispatch: Dispatch) => {
  // reset customDimension when close ai widget for both layouts
  dispatch(setCustomWidgetDimensions('codeAndResult', CodeDividers.CODE_DIVIDER, 50))
  dispatch(setCustomWidgetDimensions('codeAndResult', CodeDividers.RESULT_DIVIDER, 50))
  dispatch(setCustomWidgetDimensions('codeAndResult', CodeDividers.DOCS_DIVIDER, 50))
  dispatch(setCustomWidgetDimensions('codeAndResult', CodeDividers.PREVIEW_DIVIDER, 50))
  dispatch(setCustomWidgetDimensions('codeAndResult', CodeDividers.DIAGRAM_DIVIDER, 100))
  dispatch(setCustomWidgetDimensions('result', CodeDividers.RESULT_DIVIDER, 50))
  dispatch(setCustomWidgetDimensions('result', CodeDividers.DOCS_DIVIDER, 50))
  dispatch(setCustomWidgetDimensions('result', CodeDividers.DIAGRAM_DIVIDER, 100))
  dispatch(setCustomWidgetDimensions('result', CodeDividers.PREVIEW_DIVIDER, 50))
  dispatch(setCodeDivider(CodeDividers.DIAGRAM_DIVIDER, 100))

  // Reset codeaihelper when close
  dispatch(setCustomWidgetDimensions('result', CodeDividers.CODE_AI_HELPER_DIVIDER, undefined))
  dispatch(
    setCustomWidgetDimensions('codeAndResult', CodeDividers.CODE_AI_HELPER_DIVIDER, undefined)
  )
  dispatch(setCodeDivider(CodeDividers.CODE_AI_HELPER_DIVIDER, undefined))
}
